<template>
	<page-container :page="page">
		<section class="divider-heading">
			<div class="row">
				<div class="columns column12 align-center">
					<h1>{{ page.header }}</h1>
				</div>
				<div class="horizontal-divider large" />
			</div>
		</section>
		<section class="intro-bar">
			<div class="columns column12">
				<div class="row">
					<div class="back-to-overview">
						<nuxt-link :to="localePath('vacancies')">
							<font-awesome-icon :icon="`fal fa-chevron-left`" size="1x" />
							<span>{{ $t('back') }}</span>
						</nuxt-link>
					</div>
					<vacancy-info :city="page.city" :locations="page.locations" :working-hours="page.workingHours" />
					<div>
						<a v-if="page.url" :href="page.url" target="_blank" class="button button-cta">{{
							$t('applyForVacancy')
						}}</a>
						<a v-else href="#vacancyformwrapper" class="button button-cta">{{ $t('applyForVacancy') }}</a>
					</div>
				</div>
			</div>
		</section>

		<main-content class="wide">
			<template #main-content>
				<div class="row">
					<div v-parse-links class="columns column6" v-html="page.content" />
					<div v-parse-links class="columns column6" v-html="page.contentRight" />
				</div>
				<div class="row">
					<div class="columns column6">
						<picture>
							<source :srcset="page.midSectionImage" />
							<source :srcset="page.midSectionImageWebp" type="image/webp" />
							<img :src="page.midSectionImage" loading="lazy" class="midsection-image" />
						</picture>
					</div>
					<div v-parse-links class="columns column6" v-html="page.midSectionContent" />
				</div>
			</template>
		</main-content>

		<section v-if="!page.url" id="vacancyformwrapper" class="vacancy-form">
			<div class="row">
				<div class="form align-center">
					<h2>{{ $t('applyForVacancy') }}</h2>
					<contact-form name="vacancyform" :form="form" :extra-querydata="{ id: page.pageID }" />
				</div>
			</div>
		</section>

		<contentblocks :items="page.contentblocks" />

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();

useRemoveFormitable();

const { data: form } = await useWebsiteFetch('vacancyform', {
	query: { language: locale.value },
	key: `${locale.value}/vacancyform`,
});
</script>

<style lang="scss" scoped>
.divider-heading {
	padding-bottom: 0;

	.horizontal-divider {
		margin: 60px auto 0;
	}
}

.intro-bar {
	padding: 35px 0;

	.row {
		justify-content: space-between;
		align-items: center;
	}

	.button-cta {
		min-width: 170px;
	}
}

.back-to-overview {
	position: relative;
	min-width: 170px;
	background: none;
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;

	a {
		color: var(--body-color);
		text-decoration: none;
		text-transform: uppercase;
		padding: 0 0 5px;
	}

	svg {
		font-size: 18px;
		margin: 1px 15px -1px 0;
	}
}

.main-content {
	padding: 50px 0 0;

	:deep(h2),
	:deep(h3),
	:deep(h4) {
		margin: 0 0 10px;
	}

	.row {
		max-width: 1240px;
		padding-bottom: 50px;

		.column6 {
			padding: 0 50px 30px;
		}
	}
}

.vacancy-form .row {
	max-width: 1320px;
	background-color: var(--secondary-background-color);

	.form {
		padding: 50px;
	}
}

@media (max-width: 1080px) {
	.main-content .row {
		padding-bottom: 0;

		.column6 {
			padding: 0 20px 30px;
		}
	}
}

@media (max-width: 680px) {
	.intro-bar .row {
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
		gap: 10px;

		.button {
			margin: 10px auto 0;
		}
	}
}
</style>
